import { z } from 'zod';
import { Dashboard } from '@/services/dashboards/fusion-dashboards-service';
import { HttpClient } from '@sisense/sdk-rest-client';

/**
 * Canonical tool description for getDashboards — reusable by any host (sdk-assistant, MCP server, custom integrations).
 * Hosts may append host-specific notes but should not duplicate or contradict this text.
 */
export const getDashboardsToolDescription = `Get a list of available Fusion dashboards created by the assistant (or exposed by the host).

Do not read the raw tool result as a list to the user. Use it internally, then suggest one or two concrete follow-ups (e.g. which dashboard to open or extend) instead of dumping every title.`;

/**
 * Schema for getDashboards engine parameters
 */
export const getDashboardsSchema = z.object({});

/**
 * Context interface for getDashboardsEngine
 */
export interface GetDashboardsContext {
	/**
	 * Tool call ID
	 */
	toolCallId: string;
	httpClient?: HttpClient;
}

/**
 * Result from getDashboardsEngine
 */
export interface DashboardsResult {
	/**
	 * List of dashboards
	 */
	dashboards: Dashboard[];
}
